// extracted by mini-css-extract-plugin
export var categorySizeFull = "noOo5";
export var categorySizeMediumOrCompact = "ebw0l";